import type { GovernedLibraryDocumentSummary } from "../api/cognitoryLibraryClient";
import type { GovernedLibraryUploadSuccess } from "../api/cognitoryLibraryUploadClient";

export function buildUploadPlaceholderDocument(
  upload: GovernedLibraryUploadSuccess,
): GovernedLibraryDocumentSummary {
  return {
    documentId: upload.documentId,
    title: upload.title,
    filename: upload.filename,
    contentType: "application/pdf",
    documentStatus: "active",
    currentVersionId: upload.documentVersionId,
    versionStatus: upload.versionStatus,
    versionCreatedAt: new Date().toISOString(),
    governedSourceRecorded: true,
    canonicalState: "processing",
  };
}
